import axios from 'axios'
import getHeaders from '@/api/headersSetting'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: getHeaders()
})

export async function getPaymentMethodsOptions ({ headers, data }) {
  const params = {
    url: '/internal-commons/v1/payments/payment-methods-options',
    headers,
    params: {
      ...data
    },
    method: 'GET'
  }

  const response = await instance(params)
  return response
}

export async function getUserData (cpf, isEmployee) {
  const params = {
    url: `/internal-health/v1/paguemenos/customers/${cpf}`,
    params: {
      is_employee: isEmployee
    },
    method: 'GET'
  }

  const response = await instance(params)
  return response
}

export async function getAddressByPostalCode (zipcode) {
  const params = {
    url: `/internal-commons/v1/address/cep/${zipcode}`,
    method: 'GET'
  }

  const response = await instance(params)
  return response
}

export async function getCardBrand ({ bin, data }) {
  const params = {
    url: `/internal-commons/v1/payments/verify_card/${bin}`,
    params: {
      ...data
    },
    method: 'GET'
  }

  const response = await instance(params)
  return response
}

export async function setPromoCode ({ apiPath, data }) {
  const { path, version } = apiPath
  const params = {
    url: `/${path}/${version}/promocode/${data}`,
    method: 'GET'
  }

  const response = await instance(params)
  return response
}

export async function getVoucher ({ code, cpf }) {
  const params = {
    url: '/internal-commons/v1/promo-codes/voucher',
    params: { code, cpf },
    method: 'GET'
  }

  const response = await instance(params)
  return response
}

export async function patchtLead ({ leadUuid, cookieGA, data }) {
  if (!leadUuid) return

  const params = {
    url: `/internal-commons/v2/lead/${leadUuid}`,
    method: 'PATCH',
    ...(cookieGA && {
      headers: {
        'cookie-ga': cookieGA
      }
    }),
    data
  }

  const response = await instance(params)
  return response
}

export async function postLead ({ cookieGA, data }) {
  const params = {
    url: '/internal-commons/v2/lead',
    ...cookieGA && { headers: { 'cookie-ga': cookieGA } },
    method: 'POST',
    data
  }

  const response = await instance(params)
  return response
}

export async function calculatePromoCode ({ amount, bin, planUuid, product, promocode }) {
  const params = {
    url: `/internal-commons/v1/promo-codes/${promocode.toLowerCase()}`,
    method: 'PATCH',
    headers: {
      'x-action': 'calculate',
      product,
      ...(bin && { bin })
    },
    data: {
      planUuid,
      value: amount
    }
  }

  const response = await instance(params)
  return response
}

export async function postInstallments (data) {
  const params = {
    url: '/internal-commons/v1/payments/installments',
    method: 'POST',
    data
  }

  const response = await instance(params)
  return response
}

export async function createPlanApi ({ headersData, paymentData }) {
  const params = {
    url: '/internal-health/v3/purchases',
    method: 'POST',
    data: paymentData,
    headers: {
      ...headersData,
      partner: 'paguemenos'
    }
  }

  const response = await instance(params)
  return response
}

export async function getDefaultPlan (partner) {
  const params = {
    url: `${process.env.VUE_APP_API_URL}/internal-health/v1/plans?distribuitionPartner=${partner}`,
    headers: {
      partner: 'paguemenos'
    },
    method: 'GET'
  }
  const response = await instance(params)

  if (response.status >= 400) {
    throw new Error('Erro na busca do plano')
  }
  return response
}

export async function postQuotation (payload) {
  const params = {
    url: `${process.env.VUE_APP_API_URL}/internal-commons/v1/quotations`,
    headers: {
      partner: 'paguemenos'
    },
    method: 'POST',
    data: {
      product: 'sempre_bem',
      ...payload
    }
  }

  const response = await instance(params)
  return response
}

export async function getQuotations ({ product, id }) {
  const params = {
    url: `/internal-commons/v1/quotations/${product}/${id}`,
    method: 'GET'
  }

  const response = await instance(params)
  return response
}

export default instance
